(function () {
  'use strict';

  angular.module('app').component('hotelCostsAndPrices', hotelCostsAndPrices());

  function hotelCostsAndPrices() {
    return {
      bindings: {
        hotel: '<',
        onCostsAndPricesSaved: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: HotelCostsAndPricesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/hotels/components/hotel-costs-and-prices/hotel-costs-and-prices.component.html',
    };
  }

  function HotelCostsAndPricesComponent() {
    const vm = this;

    vm.$onInit = function () {
      vm.showCosts = true;
      vm.showPrices = true;

      // Initilizers
      vm.zonesByProduct = [];
    };

    vm.onSeasonSelected = function (season) {
      vm.seasonSelected = season;
    };

    vm.onProductCostsAndPricesSaved = function (associated_providers) {
      vm.onCostsAndPricesSaved({ associated_providers: associated_providers });
    };
  }
})();
